import { Plan, type PlanStatus } from "./schemas/plan.js";

// Pure plan-list parsing + ordering, shared by every surface that loads
// /api/me/plans (mobile's PlanScreen fetch + the @jackedlogs/ui usePlans
// hook). Mirrors parseProgramsList — one parse/sort, so a fix lands once.

const STATUS_PRIORITY: Record<PlanStatus, number> = {
  scheduled: 0,
  draft: 1,
  completed: 2,
  skipped: 3,
};

// Sort: scheduled-for-soon first, then drafts, completed, skipped. Within a
// status, scheduledFor ascending (next session at the top). Unscheduled rows
// ride at the end of their status bucket using the updatedAt fallback so the
// most-recently-edited surface wins.
export const sortPlans = (plans: ReadonlyArray<Plan>): Plan[] => {
  return [...plans].sort((a, b) => {
    const ps = STATUS_PRIORITY[a.status] - STATUS_PRIORITY[b.status];
    if (ps !== 0) return ps;
    const aDate = a.scheduledFor ?? "";
    const bDate = b.scheduledFor ?? "";
    if (aDate && bDate) return aDate.localeCompare(bDate);
    if (aDate) return -1;
    if (bDate) return 1;
    return b.updatedAt.localeCompare(a.updatedAt);
  });
};

// Parse a GET /api/me/plans payload into sorted, schema-valid plans.
// Schema-drift rows are dropped (never throw on one bad row).
export const parsePlansList = (raw: unknown): Plan[] => {
  if (!Array.isArray(raw)) return [];
  const out: Plan[] = [];
  for (const item of raw) {
    const parsed = Plan.safeParse(item);
    if (parsed.success) out.push(parsed.data);
  }
  return sortPlans(out);
};
